/**
 * HeroImage — the SINGLE hero-image container used across every service page.
 *
 * Contract (must not change per page):
 *   • Fixed aspect-ratio 4:3
 *   • object-fit: cover, centered
 *   • Same rounded-3xl, same border, same shadow, same watermark
 *   • Container width follows parent grid column; the image never scales
 *     independently. Parent grids across all service pages must use the same
 *     column ratio (lg:col-span-5 in a 12-col grid) for identical rendered size.
 *
 * The image itself changes. The container NEVER changes.
 */
import React from 'react';
import { KitxensCloud } from './Logo';

export default function HeroImage({ image, eager = true, watermark = true }) {
  const src = image?.src || '';
  const alt = image?.alt || '';

  return (
    <div className="relative">
      <div className="relative w-full aspect-[4/3] rounded-3xl border border-orange-100 shadow-[0_30px_80px_-40px_rgba(247,127,17,0.35)] overflow-hidden bg-gradient-to-br from-orange-50/70 to-white">
        {src ? (
          <img
            src={src}
            alt={alt}
            loading={eager ? 'eager' : 'lazy'}
            decoding="async"
            className="absolute inset-0 w-full h-full object-cover object-center select-none"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-[11px] tracking-[0.2em] font-semibold text-[#F77F11]/50 uppercase">
              Hero image coming soon
            </span>
          </div>
        )}
        {watermark && src && (
          <div
            aria-hidden="true"
            className="pointer-events-none absolute bottom-3 right-3 flex items-center gap-1.5 rounded-full bg-white/70 backdrop-blur-md px-2.5 py-1 shadow-sm ring-1 ring-white/50"
          >
            <KitxensCloud className="w-3.5 h-3.5" />
            <span className="text-[10px] font-semibold tracking-[-0.005em] text-neutral-800/80">
              kit<span className="text-[#F77F11]">x</span>ens
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
